import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  entrantsEventList: {
    data: []
  },
};

export const entrantsEventListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ENTRANTS_EVENT_LIST:
      return {
        ...state,
        entrantsEventList: action.payload,
      };
    default:
      return state;
  }
};
